var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckOutlineIcon = function SvgCheckOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.586.736a1.17 1.17 0 0 0-1.402.067l-.096.089-8.077 9.281-3.574-3.701a1.174 1.174 0 0 0-1.706 0 1.308 1.308 0 0 0-.09 1.695l.09.103 4.415 4.574a1.178 1.178 0 0 0 1.599.101l.099-.09 8.94-10.153c.414-.43.473-1.096.17-1.582l-.076-.109-.083-.097-.111-.103-.098-.075z",
    fill: "var(--colors-brand)",
    fillRule: "evenodd"
  })));
};

export default SvgCheckOutlineIcon;